import { Button, Carousel } from "antd";
import { Image } from "cloudinary-react";
import moment from "moment";
import Link from "next/link";
import { useRouter } from "next/router";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import useSWR from "swr";
import Footer from "../../components/global/Footer/Footer";
import fetcher from "../../fetchers/fetcher";
import { EventWrapper } from "./Event.style";

export default function Event() {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const router = useRouter();

  const { data: event } = useSWR(
    process.env.API_URL + "/events/" + router.query.slug,
    fetcher
  );
  const { data: events } = useSWR(
    process.env.API_URL + "/events",
    fetcher
  );

  if (!event || !events) {
    return <>loading...</>;
  }

  return (
    <>
      <EventWrapper>
        <div className="titleWrapper">
          <h1 id="mainTitle">{event.title}</h1>
          <hr />
        </div>
        <Carousel
          autoplay={isDesktop}
          arrows={isDesktop}
          nextArrow={<FaAngleRight />}
          prevArrow={<FaAngleLeft />}
        >
          {event.photos.map((photo, index) => {
            return (
              <Image
                cloudName="easycapital"
                src={photo.photo}
                alt={photo.description ?? "event picture"}
                key={index}
              />
            );
          })}
        </Carousel>
        <div className="content">
          <p>
            Par {event.presenter.firstname}
            <br />
            Présentation effectuée le{" "}
            {moment(event.created_at).format("DD/MM/YYYY")}
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: event.formatted_description,
            }}
          />
        </div>
        <h2>Les évènements d'Easy Capital</h2>
        <Carousel autoplay className="allEvents">
          {events.map((e, index) => {
            return (
              <Image
                cloudName="easycapital"
                src={e.photos[0].photo}
                alt={e.photos[0].description ?? "event picture"}
                key={index}
              />
            );
          })}
        </Carousel>
        <div className="eventsDescription">
          <p>
            Notre cabinet propose des ateliers sur plusieurs thématiques, du
            coaching à l'optimisation de votre situation fiscale et
            patrimoniale, chez nous ou chez vous !
          </p>
          <p>
            Suivez-nous sur LinkedIn afin d’être au courant de nos prochains
            événements et de vous y inscrire.
          </p>
          <p>
            Si vous souhaitez organiser un échange au sein de votre entreprise
            cliquez sur le bouton Contactez-nous afin que l’on vous recontacte !
          </p>
        </div>
        <Link href={"/start"}>
          <Button className="btn contact-us">Contactez-nous</Button>
        </Link>
      </EventWrapper>
      <Footer />
    </>
  );
}
